import { Pin, PinOff } from "lucide-react";
import React from "react";
import { convertConversationToJapanTime } from "../utils/helpers";
export const CustomConversationOperations = ({ user, onUnPinned, onPinned }) => {
    if (!user) {
        return null;
    }
    const isPinned = user.pinned_conversation_at ? true : false;
    const onTogglePin = user => {
        if (user.pinned_conversation_at) {
            onUnPinned(user.id);
        }
        else {
            onPinned(user.id);
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "c-conversation-action"
    }, /*#__PURE__*/ React.createElement("span", {
        className: "c-conversation-action__send-time text-gray-500"
    }, convertConversationToJapanTime(new Date(user.last_message.time))), /*#__PURE__*/ React.createElement("button", {
        onClick: () => onTogglePin(user)
    }, isPinned ? /*#__PURE__*/ React.createElement(PinOff, {
        size: "16px"
    }) : /*#__PURE__*/ React.createElement(Pin, {
        size: "16px"
    })));
};
